// Persistent beta-environment marker. Unlike ConnectionBanner (transient, position:fixed),
// this is ALWAYS shown and rendered in normal document flow so it pushes content down
// rather than permanently covering ~30px of every page. Shown on every route incl. /login.
//
// Mobile (≤768px): a single slim strip with a session-only ✕ dismiss (in-memory state, NOT
// localStorage — reappears on reload, which is fine for a beta marker). Desktop unchanged.
//
// TEMPORARY: this is a launch/beta marker — remove (or gate behind an env flag) at GA.
import { useState } from 'react';
import { useIsMobile } from '../lib/useIsMobile';

export default function BetaBanner() {
  const isMobile = useIsMobile();
  const [dismissed, setDismissed] = useState(false); // in-memory only (session dismiss)

  if (isMobile) {
    if (dismissed) return null;
    return (
      <div
        role="status"
        aria-label="Beta environment"
        style={{
          position: 'relative',
          width: '100%', boxSizing: 'border-box',
          background: '#b45309', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '5px 44px 5px 10px', minHeight: 26,
          fontSize: 11, fontWeight: 700, letterSpacing: 0.3,
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        ⚠ BETA · test environment
        {/* 44px-wide hit area spanning the strip height (the strip is slimmer than 44px, so the
            target extends edge-to-edge vertically instead — the whole right end is the button). */}
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss beta banner"
          title="Dismiss beta banner"
          style={{
            position: 'absolute', top: 0, bottom: 0, right: 0, width: 44,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'none', border: 'none', color: '#fff', opacity: 0.9,
            fontSize: 14, lineHeight: 1, cursor: 'pointer', padding: 0,
          }}
        >
          ✕
        </button>
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-label="Beta environment"
      style={{
        width: '100%',
        background: '#b45309', color: '#fff',
        textAlign: 'center', padding: '6px 16px',
        fontSize: 12.5, fontWeight: 700, letterSpacing: 0.2,
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      BETA — test environment. Features and data may change.
    </div>
  );
}
